import { ProductImageModel } from './productImageModel';
import { ProductToProductModel } from './productToProductModel';

export class ProductModel {
    public productId: number;
    public categoryId?: number;
    public category: number;
    public unitId: number;
    public article: string;
    public articleNumber: string;
    public brand: string;
    public model: string;
    public price: number;
    public priceFromSupplier: number;
    public power: number;
    public secondPower: number;
    public discount: number;
    public supplier: string;
    public description: number;
    public isActive: boolean;
    public relatedProducts: Array<ProductToProductModel>;
    public quantity: number;
    public productImage: ProductImageModel
    public fileId: number;
    public diameter: number;
}